import { render } from "./wind_values.vue?vue&type=template&id=c91837d8"
import script from "./wind_values.vue?vue&type=script&lang=js"
export * from "./wind_values.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__